import React, {FC, useState} from "react"

import ProfilePicture from "@irati/ui/src/ProfilePicture"

import Icon, {IconTypes} from "@irati/ui/src/Icon"
import HeaderLink from "../shared/HeaderLink"
import {USER_MENU_CONTEXT} from "./const"

interface Props {
  id: any
  user: any
  togglePanel: (key?: string) => void
}

const MobileMenuToggle: FC<Props> = ({user, togglePanel}) => {
  if (!user) return null
  const [isMenuDisplayed, setIsMenuDisplayed] = useState<boolean>(false)

  const handleClick = () => {
    setIsMenuDisplayed((current) => !current)
    togglePanel(USER_MENU_CONTEXT)
  }

  return (
    <HeaderLink data-attach-tooltip="usermenu" onClick={handleClick}>
      <ProfilePicture user={user} small />
      <Icon marginLeft large icon={isMenuDisplayed ? IconTypes.chevronUp : IconTypes.chevronDown} id="mobileChevronArrow" />
    </HeaderLink>
  )
}

export default MobileMenuToggle
